<template>


    <div :class="[other_integrations_filtered.length > 0 ? 'pb-24' : '', 'grid grid-cols-3 gap-y-8 gap-x-3']">


        <div v-for="integration in activated_integrations" :key="integration.slug"
            class="bg-white sm:rounded-md col-span-3 border border-gray-200">
            <a :name="integration.slug" :id="integration.slug"></a>
            <component :is="integration.component" v-bind="integration.extraProps" @update="update_integrations">
            </component>
        </div>

        <div v-if="other_integrations.length > 0"
            :class="[activated_integrations.length > 0 ? 'mt-16' : '', 'col-span-3']">
            <div class="flex flex-row items-center gap-x-2 rounded-md py-1 px-0 mb-3">
                <h3 class="text-base font-medium text-gray-900">Helpdesks</h3>
                <input type="text" v-model="search" placeholder="search…"
                    class="text-left text-sm w-full inline py-2 px-3 border border-gray-300 focus:ring-0 focus:border-blue-500 bg-white focus:bg-white text-birdie-blue focus:text-blue-600 rounded-lg ml-4 max-w-xs" />

            </div>
        </div>

        <div v-for="integration in other_integrations_filtered" :key="integration.slug"
            class="col-span-3 bg-white sm:rounded-md border border-gray-200">
            <a :name="integration.slug" :id="integration.slug"></a>
            <component :is="integration.component" v-bind="integration.extraProps" @update="update_integrations">
            </component>
        </div>


        <div class="" v-if="is_modal">
            <div class="flex flex-row justify-center px-4">
                <jet-secondary-button @click="$inertia.visit(route('settings.index') + '#integrations')">
                    Settings page for more details
                    <vue-feather type="arrow-right" class="w-4 h-4 ml-2" />
                </jet-secondary-button>
            </div>
        </div>

    </div>

</template>
<script>
import JetSectionBorder from '@/Jetstream/SectionBorder'
import JetSecondaryButton from '@/Jetstream/SecondaryButton'
import IntegrationIntercom from '@/Components/Settings/Integrations/Intercom'
import IntegrationHubspot from '@/Components/Settings/Integrations/Hubspot'
import IntegrationZendesk from '@/Components/Settings/Integrations/Zendesk'
import IntegrationJira from '@/Components/Settings/Integrations/Jira'
import IntegrationHelpscout from '@/Components/Settings/Integrations/Helpscout'
import IntegrationFreshchat from '@/Components/Settings/Integrations/Freshchat'
import IntegrationFreshdesk from '@/Components/Settings/Integrations/Freshdesk'
// import IntegrationAircall from '@/Components/Settings/Integrations/Aircall'
// import IntegrationSalesforce from '@/Components/Settings/Integrations/Salesforce'
import IntegrationHappyfox from '@/Components/Settings/Integrations/Happyfox'
import IntegrationUl from '@/Components/Settings/Integrations/UniversalLink'

export default {

    props: ["integrations", "is_modal", "zendesk_snippet", "zendesk_autoreply",
        "freshdesk_snippet", "freshdesk_autoreply", "happyfox_snippet", "zendesk_snippet_installed",
        "helpscout_autoreply", "integration_bank", "initial_universal_recorders","hubspot_snippet"],

    components: {
        JetSectionBorder, JetSecondaryButton,
        IntegrationIntercom, IntegrationZendesk, IntegrationJira,
        IntegrationHelpscout,
        IntegrationFreshchat, IntegrationFreshdesk,
        // IntegrationAircall,
        // IntegrationSalesforce,
        IntegrationHappyfox, IntegrationUl, IntegrationHubspot
    },

    data() {
        return {
            activated_integrations: [],
            other_integrations: [],
            search: '',
            universal_recorders: this.initial_universal_recorders
        }
    },


    created() {

    },
    mounted() {
        this.dispatchIntegrations()
    },

    computed: {
        other_integrations_filtered() {
            if (this.search == '') {
                return this.other_integrations
            }
            return this.other_integrations.filter(integration => {
                return integration.name.toLowerCase().includes(this.search.toLowerCase()) || integration.slug.toLowerCase().includes(this.search.toLowerCase()) || integration.slug.toLowerCase() == ''
            })
        }
    },

    methods: {

        update_integrations(new_universal_recorders, slug) {
            const is_added = new_universal_recorders.length > this.universal_recorders.length
            this.universal_recorders = new_universal_recorders

            this.dispatchIntegrations()

            if (is_added) {
                setTimeout(() => {
                    const element = document.getElementById(slug)
                    if (element) {
                        element.scrollIntoView({ behavior: 'smooth' })
                    } else {
                        window.scrollTo({
                            top: 0,
                            behavior: 'smooth'
                        })
                    }
                }, 200)
            }
        },

        dispatchIntegrations() {
            this.activated_integrations = []
            this.other_integrations = []

            let custom_integration_blank = null

            var intercom_found = false

            for (var i = 0; i < this.integration_bank.length; i++) {

                let found = false;
                let integration = JSON.parse(JSON.stringify(this.integration_bank[i]))

                integration.extraProps = {
                    is_modal: this.is_modal,
                    the_trigger: false,
                    clicked: false,
                    enabled: false,
                    is_custom: integration.slug == ''
                }
                for (var key in integration) {
                    if (key != 'component' && key != 'extraProps') {
                        integration.extraProps[key] = integration[key]
                    }
                }

                if (integration.universal && integration.slug == '') {
                    custom_integration_blank = integration
                    continue
                }


                for (var j = 0; j < this.integrations.length; j++) {
                    if (this.integrations[j].name == integration.slug) {
                        found = true
                        if (integration.slug == 'intercom' && !intercom_found) {
                            const trigger_s = this.get_integration(integration.slug)
                            integration.extraProps.the_triggers = JSON.parse(JSON.stringify(trigger_s))
                            // console.log("trigger_s", trigger_s, intercom_found)
                            intercom_found = true
                        } else if (!integration.universal && integration.slug != 'intercom') {
                            const trigger_s = this.get_integration(integration.slug)
                            integration.extraProps.the_trigger = JSON.parse(JSON.stringify(trigger_s))
                            if (integration.slug == 'zendesk') {
                                integration.extraProps.zendesk_snippet = this.zendesk_snippet
                                integration.extraProps.zendesk_autoreply = this.zendesk_autoreply
                                integration.extraProps.zendesk_snippet_installed = this.zendesk_snippet_installed
                            } else if (integration.slug == 'freshdesk') {
                                integration.extraProps.freshdesk_snippet = this.freshdesk_snippet
                                integration.extraProps.freshdesk_autoreply = this.freshdesk_autoreply
                            } else if (integration.slug == 'happyfox') {
                                integration.extraProps.happyfox_snippet = this.happyfox_snippet
                            } else if (integration.slug == 'helpscout') {
                                integration.extraProps.helpscout_autoreply = this.helpscout_autoreply
                            } else if (integration.slug == 'hubspot') {
                                integration.extraProps.hubspot_snippet = this.hubspot_snippet
                            }
                        } else {
                            integration.extraProps.the_trigger = true
                            // the_trigger: false, name: "Hubspot", slug: "hubspot", docs: "https://docs.birdie.so/birdie-docs/helpdesk/hubspot", logo: "hubspot-logo.svg", logoSize: "7", color: "#ED6744", enabled: this.hubspot_enabled
                            // integration.extraProps.the_trigger = trigger_s
                        }
                        this.activated_integrations.push(integration)
                        break
                    }
                }

                if (found) {
                    continue
                }

                if (!integration.universal) {
                    this.other_integrations.push(integration)
                    continue
                }

                let universal_found = false
                for (var j = 0; j < this.universal_recorders.length; j++) {
                    if (this.universal_recorders[j].slug == integration.slug) {
                        integration.extraProps.the_trigger = true
                        integration.extraProps.enabled = true
                        this.activated_integrations.push(integration)
                        universal_found = true
                        break
                    }
                }

                if (!universal_found && integration.slug != '') {
                    this.other_integrations.push(integration)
                    continue
                }
            }

            // now custom integrations if any

            let custom_integration_found = null

            //console.log("universal_recorders", this.universal_recorders)

            for (var j = 0; j < this.universal_recorders.length; j++) {
                let is_listed = false
                for (var i = 0; i < this.integration_bank.length; i++) {
                    if (this.integration_bank[i].universal &&
                        this.universal_recorders[j].slug == this.integration_bank[i].slug) {
                        is_listed = true
                        break
                    }
                }
                if (!is_listed) {
                    custom_integration_found = this.universal_recorders[j]
                    break
                }
            }

            // console.log("custom_integration_found", custom_integration_found)
            if (custom_integration_found) {
                custom_integration_blank.slug = custom_integration_found.slug
                custom_integration_blank.name = custom_integration_found.name
                custom_integration_blank.extraProps.slug = custom_integration_found.slug
                custom_integration_blank.extraProps.name = custom_integration_found.name
                custom_integration_blank.extraProps.the_trigger = true
                custom_integration_blank.extraProps.enabled = true
                this.activated_integrations.push(custom_integration_blank)
            } else {
                //console.log("custom_integration_blank", custom_integration_blank)
                this.other_integrations.push(custom_integration_blank)
            }

            // this.activated_integrations = []
            // this.other_integrations = []
            // console.log("activated_integrations", this.activated_integrations)
            // console.log("other_integrations", this.other_integrations)
        },

        get_integration(slug) {
            var intercomInstances = [];
            for (var i = 0; i < this.integrations.length; i++) {
                if (this.integrations[i].name == slug) {
                    if (slug != 'intercom') {
                        return this.integrations[i]
                    } else {
                        intercomInstances.push(this.integrations[i])
                    }
                }
            }
            if (slug == 'intercom' && intercomInstances.length > 0) {
                return intercomInstances
            }
            return false
        },
    }

}
</script>
